const ACCESS_ERROR_MESSAGE = 'Campaign access could not be verified. Please try again.';

export async function verifyCampaignCreationAccess(refreshCampaignAccess) {
  try {
    const access = await refreshCampaignAccess();
    return {
      allowed: access?.canStart === true && access?.canAutomate === true,
      message: typeof access?.maintenanceMessage === 'string' && access.maintenanceMessage.trim()
        ? access.maintenanceMessage.trim()
        : ACCESS_ERROR_MESSAGE
    };
  } catch (_error) {
    return { allowed: false, message: ACCESS_ERROR_MESSAGE };
  }
}
